import { Reveal } from "@/components/Reveal";

const Vision = () => (
  <section
    data-testid="vision-section"
    className="relative overflow-hidden bg-[#3F5A47] px-6 py-28 lg:py-44"
  >
    <img
      src="/brand/vision-dandelion.png"
      alt=""
      className="pointer-events-none absolute -right-8 top-1/2 hidden w-[320px] -translate-y-1/2 lg:block"
    />
    <div className="relative mx-auto max-w-3xl lg:ml-[10%] lg:mr-auto">
      <Reveal>
        <p className="font-serif text-3xl leading-snug text-[#FAF7F1] sm:text-4xl lg:text-5xl">
          Vi vil ikke bare få mennesker til at passe bedre ind i rammerne.
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-12 font-serif text-3xl leading-snug text-[#FAF7F1] sm:text-4xl lg:text-5xl">
          Vi vil skabe rammer, der kan rumme mennesker.
        </p>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-16 max-w-xl font-sans text-sm leading-relaxed text-[#FAF7F1]/80 sm:text-base">
          Mennesker med forskellige udtryk, kulturer, livshistorier, erfaringer, kontekster og
          reaktionsmønstre.
        </p>
      </Reveal>
      <Reveal delay={0.26}>
        <p className="mt-20 font-serif text-xl leading-relaxed text-[#D6C2A6] sm:text-2xl">
          Vi vil bidrage til mere menneskelige, ligeværdige og bæredygtige organisationer,
          fællesskaber og samfund.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Vision;
